/**
 * Environment Access Control Utility
 */


export function isDevOrTestEnvironment(): boolean {
	const hostname = window.location.hostname;
	return hostname.includes('.dev-genesys.cloud') || hostname.includes('.test-genesys.cloud');
}


export function isUserAuthorized(): boolean {
	return localStorage.getItem('developer') === 'true';
}

/**
 * Converts a dev/test URL to the production URL
 * @returns {string} The production URL
 */
export function getProductionUrl(): string {
	const url = window.location.href;
	const urlObj = new URL(url);
	
	// Replace dev/test subdomain with production domain
	let newHostname = urlObj.hostname;
	if (newHostname.includes('.dev-genesys.cloud')) {
		newHostname = newHostname.replace('.dev-genesys.cloud', '.genesys.cloud');
	} else if (newHostname.includes('.test-genesys.cloud')) {
		newHostname = newHostname.replace('.test-genesys.cloud', '.genesys.cloud');
	}
	
	// Construct new URL with production hostname
	const productionUrl = new URL(urlObj.pathname + urlObj.search + urlObj.hash, `https://${newHostname}`);
	return productionUrl.toString();
}

/**
 * Checks if access control should be enforced and redirects if necessary
 * @returns {boolean} True if redirect was performed, false if access is allowed
 */
export function enforceAccessControl(): boolean {
	// Only enforce on dev/test environments
	if (!isDevOrTestEnvironment()) {
		return false;
	}
	
	// get query params and check for developer flag
	const urlParams = new URLSearchParams(window.location.search);
	const developer = urlParams.get('developer');
	if (developer === 'true') {
		localStorage.setItem('developer', 'true');
		return false;
	}

	// Check if user is authorized
	if (!isUserAuthorized()) {
		// Redirect to production site
		const productionUrl = getProductionUrl();
		console.log('Redirecting unauthorized user to production site:', productionUrl);
		window.location.href = productionUrl;
		return true;
	}
	
	return false;
}
